import React, { useEffect } from 'react';
import { Icon } from '../../../../../base/components/Icon';
import { __t } from '../../../../../base/utils/t';
import { useAppDispatch, useAppSelector, useRoutesWithLang } from '../../../../../base/hooks';
import { Link, useLocation } from 'react-router-dom';
import { AuthRoutes } from '../../routes';
import { loginActions } from '../../redux/slices/loginSlice';
import { PhoneInput } from '../../../../../base/components/Forms/PhoneInput';
import { PasswordInput } from '../../../../../base/components/Forms/PasswordInput';
import { Button } from '../../../../../base/components/Button';
import { AuthRoutes as RecruiterAuthRoutes } from '../../../../../recruiter/units/authorization/routes';

import './styles.scss';

export const Login = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const {
        fields: { phone, password },
        errors,
    } = useAppSelector((state) => state.workerAppLogin);
    const { phoneInputConfig } = useAppSelector((state) => state.workerApp.config);
    const authRoutes = useRoutesWithLang<typeof AuthRoutes>(AuthRoutes);
    const recruiterAuthRoutes = useRoutesWithLang<typeof RecruiterAuthRoutes>(RecruiterAuthRoutes);

    useEffect(() => {
        return function () {
            dispatch(loginActions.setField({ id: 'phone', value: '' }));
            dispatch(loginActions.setField({ id: 'password', value: '' }));
        };
    }, []);

    const loginHandler = () => dispatch(loginActions.submitLogin());

    const inputChangeHandler = (id: string, value: unknown) => {
        dispatch(loginActions.setField({ id, value }));
    };

    return (
        <div className='login-form'>
            <div className='login-form-worker'>
                <div className='login-form__form-item'>
                    <p className='login-form__form-label'>{__t('Телефон')}</p>
                    <PhoneInput
                        value={phone}
                        onChange={(value: string) => inputChangeHandler('phone', value)}
                        errors={errors?.phone}
                        onlyCountries={phoneInputConfig.countries}
                        preferredCountries={phoneInputConfig.preferredCountries}
                        localization={phoneInputConfig.localization}
                        tabIndex={1}
                    />
                </div>

                <div className='login-form__form-item'>
                    <p className='login-form__form-label'>{__t('Пароль')}</p>
                    <PasswordInput
                        value={password}
                        placeholder={__t('Введите пароль')}
                        onChange={(value: string) => inputChangeHandler('password', value)}
                        errors={errors?.password}
                        className='login-form__form-input'
                        tabIndex={2}
                    />
                    <Link
                        to={authRoutes.PasswordRecovery}
                        state={{ from: location }}
                        className='login-form__form-link login-form__recover-password-link'
                    >
                        {__t('Восстановить пароль')}
                    </Link>
                </div>

                <Button onClick={loginHandler} className='login-form__submit-button'>
                    {__t('Войти')}
                </Button>

                <div className='login-form__divider'>
                    <span className='login-form__divider-text'>{__t('или')}</span>
                </div>

                <div className='login-form__sso-buttons-wrap'>
                    <a
                        href='/site/auth?authclient=facebook'
                        className='login-form__sso-button login-form__sso-button--facebook'
                    >
                        <Icon icon='facebook-f' color='white' />
                    </a>
                    <a
                        href='/site/auth?authclient=google'
                        className='login-form__sso-button login-form__sso-button--google'
                    >
                        <Icon icon='google' color='white' />
                    </a>
                </div>

                <p className='login-form__message'>
                    {__t('Первый раз на сайте?')}{' '}
                    <Link to={authRoutes.SignUp} state={{ from: location }} className='login-form__form-link'>
                        {__t('Зарегистрируйтесь')}
                    </Link>
                </p>

                <a
                    href={`${window.GLOBALS?.crossSiteBaseUrl}${recruiterAuthRoutes.Login}`}
                    className='login-form__recruiters-link'
                >
                    <Icon icon='user-tie-hair-solid' color='highlight' className='login-form__recruiters-link-icon' />
                    {__t('Я рекрутер')}
                </a>
            </div>
        </div>
    );
};
